import { inject, Injectable } from '@angular/core';
import type { AccountLookupRequest, AccountLookupResponse } from '../models/account-lookup';
import { ShipmentFlowStateService } from '../services/shipment-flow-state.service';
import { AXIOS_INSTANCE } from './api-client.tokens';

@Injectable({ providedIn: 'root' })
export class AccountApiService {
  private readonly http = inject(AXIOS_INSTANCE);
  private readonly shipmentFlowState = inject(ShipmentFlowStateService);

  /**
   * Looks up a billing account and returns eligibility outcome from the account service.
   * Sends the wizard flow id so ALLOW_CONTINUE responses can include a JWT_acct attestation.
   */
  lookup(request: AccountLookupRequest): Promise<AccountLookupResponse> {
    const flowId = this.shipmentFlowState.ensureFlowId();

    return this.http
      .post<AccountLookupResponse>('/accounts/lookup', request, {
        headers: { 'x-flow-id': flowId },
      })
      .then((response) => response.data);
  }
}
